import type {
	OnboardingDataItemType,
	OnboardingStep,
} from "@configs/custom-app-config-schema";
import { useOnboardingContext } from "../contexts/OnboardingContext";
import { ChooseCategoryContainer } from "../screens/ChooseCategoryContainer";
import { ChooseExamContainer } from "../screens/ChooseExamContainer";
import { ChooseExamDateContainer } from "../screens/ChooseExamDateContainer";
import { ChooseLevelContainer } from "../screens/ChooseLevelContainer";
import { ChooseStateContainer } from "../screens/ChooseStateContainer";
import { PrivacyScreenContainer } from "../screens/PrivacyScreenContainer";
import type { HandleUpdateProgressHandler, NextButtonHandler } from "../types";

type Props = {
	stepData: OnboardingStep;
	reset: () => void;
	cta?: string;
	handleNextAction: NextButtonHandler;
	handleUpdateProgress: HandleUpdateProgressHandler;
	data: OnboardingDataItemType[];
};
const OnboardingStepRenderer = ({
	stepData,
	reset,
	cta,
	handleNextAction,
	handleUpdateProgress,
	data,
}: Props) => {
	const {
		selectedCategoryId,
		selectedLevelId,
		selectedStateCode,
		handleSelect,
		filteredStates,
		categoryHasState,
		handleSearchState,
		stateQuery,
		filteredExams,
	} = useOnboardingContext();

	return (() => {
		switch (stepData.step) {
			case "chooseCategory":
				return (
					<ChooseCategoryContainer
						reset={reset}
						handleCategorySelect={(id) => handleSelect?.(id, "category")}
						selectedCategoryId={selectedCategoryId}
						categoryHasState={categoryHasState}
						cta={cta}
						handleNextAction={handleNextAction}
					/>
				);
			case "chooseLevel":
				return selectedCategoryId ? (
					<ChooseLevelContainer
						handleSelectLevel={(id) => handleSelect?.(id, "level")}
						selectedLevelId={selectedLevelId}
						cta={cta}
						handleNextAction={handleNextAction}
					/>
				) : null;
			case "chooseState":
				return selectedCategoryId ? (
					<ChooseStateContainer
						states={filteredStates ?? []}
						selectedStateCode={selectedStateCode}
						handleSelectState={(code) => handleSelect?.(code, "state")}
						handleSearchState={handleSearchState}
						searchQuery={stateQuery ?? ""}
						cta={cta}
						handleNextAction={handleNextAction}
					/>
				) : null;
			case "chooseExam":
			case "chooseContext":
				return (
					<ChooseExamContainer
						categoryId={selectedCategoryId}
						levelId={selectedLevelId}
						cta={cta}
						categoryHasState={categoryHasState}
						filteredExams={filteredExams ?? []}
						handleNextAction={handleNextAction}
					/>
				);
			// case "redeem":
			// 	return <RedeemContainer handleNext={handleNext} />;
			// case "set-date":
			// 	return (
			// 		<OnboardingTestDate
			// 			testDate={
			// 				examDate
			// 					? examDate
			// 					: DateTime.now().plus({ months: 1 }).toFormat("MMMM dd, yyyy")
			// 			}
			// 			onDateChange={updateExamDate}
			// 		/>
			// 	);
			case "examDate":
			case "set-date":
				return (
					<ChooseExamDateContainer
						cta={cta}
						handleNextAction={handleNextAction}
						handleUpdateProgress={handleUpdateProgress}
					/>
				);
			case "privacy":
				return (
					<PrivacyScreenContainer
						handleNextAction={handleNextAction}
						data={data}
						cta={cta}
					/>
				);
			default:
				return null;
		}
	})();
};

export default OnboardingStepRenderer;
